/**
 * Takes two unix timestamps and returns a double with 2 decimals
 * @param {number} a - number
 * @param {number} b - number
 * @returns {number}
 */
export const getDiffTimeAsADouble = (a: number, b: number) => Math.round(
  ((Math.abs(a - b) / 1000) + Number.EPSILON) * 100
) / 100;

export const getDaysDiffFromToday = (dateString: string) => {
  const date = new Date(dateString);
  const today = new Date();

  return Math.round((today.getTime() - date.getTime()) / (1000 * 3600 * 24));
};
